import {
	getChat200Schema,
	getChatPathParamsSchema,
	getChatQueryParamsSchema,
	replyChat200Schema,
	replyChatMutationRequestSchema,
	replyChatPathParamsSchema,
} from "../schemas/memberChatApi.schemas";
import type {
	GetChat200Response,
	ReplyChat200Response,
} from "../types/memberChatApi.types";

/**
 * Shared endpoint contract configuration for member chats
 * This ensures both client and server use the same endpoint definitions
 */
export const memberChatEndpointContract = {
	getChat: {
		path: "/members/chats/:memberId",
		method: "GET" as const,
		paramsSchema: getChatPathParamsSchema,
		querySchema: getChatQueryParamsSchema,
		responseSchema: getChat200Schema,
		responseType: {} as GetChat200Response,
	},
	replyChat: {
		path: "/members/chats/:memberId",
		method: "POST" as const,
		paramsSchema: replyChatPathParamsSchema,
		bodySchema: replyChatMutationRequestSchema,
		responseSchema: replyChat200Schema,
		responseType: {} as ReplyChat200Response,
	},
} as const;
